import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

export const ProtectedAdminRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-pearl" data-testid="admin-loading">
        <div className="w-12 h-12 border-4 border-brand-ivory/20 border-t-brand-ivory rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/hidden/admin" replace />;
  }

  return children;
};